import { jsxs, jsx } from "react/jsx-runtime";
const IconLicenceSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M19 4H5C3.346 4 2 5.346 2 7v10c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V7c0-1.654-1.346-3-3-3Zm1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10Z" }),
      /* @__PURE__ */ jsx("path", { d: "M17 8h-3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2Zm0 4h-3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2Z" }),
      /* @__PURE__ */ jsx("circle", { cx: 9, cy: 10, r: 2 }),
      /* @__PURE__ */ jsx("path", { d: "M10 13H8a2 2 0 0 0-2 2v1h6v-1a2 2 0 0 0-2-2Z" })
    ]
  }
);
export {
  IconLicenceSvg
};
